import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-sa-license-card',
  templateUrl: './sa-license-card.component.html',
  styleUrls: ['./sa-license-card.component.css']
})
export class SaLicenseCardComponent implements OnInit {

  constructor() { }

  @Input() adminList;
  @Output() propAction = new EventEmitter();
  @Output() switchAction = new EventEmitter();
  @Output() adminAction = new EventEmitter();
  @Output() selectAction = new EventEmitter();

  ngOnInit() {
  }

  stop(data) {
    
    this.propAction.emit(data);
  }

  switch(data) {
    this.switchAction.emit(data);
  }

  changeAdmin(data) {
    this.adminAction.emit(data);
    
  }

  selectAdmin(data) {
    this.selectAction.emit(data);
  }


}
